export default import.meta.ROLLDOWN_FILE_URL_fbrZh2NpoG8Hfco_29d_KA